export const AUTH = {
    SET_TOKEN: 'AUTH_SET_TOKEN',
    CLEAR_TOKEN: 'AUTH_CLEAR_TOKEN',
    SET_USER_INFORMATIONS: 'AUTH_SET_USER_INFORMATIONS',
    SET_IS_OLD_LOGIN: 'SET_IS_OLD_LOGIN',
    SET_EMAIL_AZURE: 'SET_EMAIL_AZURE',
    SET_LOADING: 'AUTH_SET_LOADING',
};
